<template>
  <router-link :to="{ name: 'Room', params: { city: city.slug }}" class="city-card" @click.native="onSelect()">
    <img :src="city.image ? city.image : require('@/assets/img/yurtlarburada-default.jpg')" alt="" class="city-card__cover">
    <div class="city-card__overlay">
      <div class="city-card__title">{{ city.name }}</div>
      <div class="city-card__subtitle">Kayıtlı Oda</div>
      <div class="city-card__number">{{ city.rooms_count }}</div>
    </div>
    <div class="city-card__cnt">
      <v-link
        class="city-card__button"
        :to="{ name: 'Room', params: { city: city.slug }}"
        title="Yurtları Görüntüle"
      />
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'CityRoomCard',
  props: {
    city: Object
  },
  methods: {
    onSelect () {
      window.localStorage.setItem('district_name', '')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/city-card";
</style>
